import { markdown, ReactSpecimen } from "catalog";
import { SearchField, SearchController, AutocompleteSuggestions } from "./Search";
const sampleTagItems = [
    { label: "Lorem ipsum", "@id": "foo", "@type": "Dimension" },
    {
        label: "dolor sit amet consectetur",
        "@id": "foo2",
        "@type": "Dimension"
    },
    { label: "adipisicing", "@id": "foo3", "@type": "Topic" },
    { label: "Eum ipsam cupiditate", "@id": "foo4", "@type": "Dimension" },
    { label: "quibusdam commodi", "@id": "foo5", "@type": "Topic" },
    { label: "ducimus esse sint", "@id": "foo6", "@type": "Dimension" },
    { label: "labore reprehenderit", "@id": "foo7", "@type": "Dimension" },
    { label: "error accusantium", "@id": "foo8", "@type": "Dimension" }
];
export default () => markdown `

## Search Controller

The \`SearchController\` handles the state of the search field, including

- focus/blur
- autocomplete suggestions
  - loading tags
  - showing/hiding suggestions
  - loading state, error handling
  - timeout (TODO)

${(<ReactSpecimen>
    <SearchController selectedTags={[]} suggestedTags={sampleTagItems} addSearchTag={() => { }} removeSearchTag={() => { }}/>
  </ReactSpecimen>)}

#### With selected tags

${(<ReactSpecimen>
    <SearchController selectedTags={[{ label: "Foo", "@id": "foo", "@type": "Dimension" }]} suggestedTags={sampleTagItems} addSearchTag={() => { }} removeSearchTag={() => { }}/>
  </ReactSpecimen>)}

## Search Field

The search field itself is stateless; state handling is done in \`SearchController\`:

${(<ReactSpecimen>
    <SearchField items={[]} selectedItems={[]} onChange={() => { }} onInputFocus={() => { }} onInputBlur={() => { }} loading={false} inFocus={false} onSelect={() => { }} onRemoveTag={() => { }} placeholderText="Suchbegriff eingeben, z.B. Bevölkerung"/>
  </ReactSpecimen>)}


${(<ReactSpecimen>
    <SearchField items={[{ label: "Foo", "@id": "foo", "@type": "Dimension" }]} selectedItems={[]} onChange={() => { }} onInputFocus={() => { }} onInputBlur={() => { }} loading={false} inFocus={false} onSelect={() => { }} onRemoveTag={() => { }} placeholderText="Suchbegriff eingeben, z.B. Bevölkerung"/>
  </ReactSpecimen>)}

${(<ReactSpecimen>
    <SearchField items={[]} selectedItems={[{ label: "Foo", "@id": "foo", "@type": "Dimension" }]} onChange={() => { }} onInputFocus={() => { }} onInputBlur={() => { }} loading={false} inFocus={false} onSelect={() => { }} onRemoveTag={() => { }} placeholderText="Suchbegriff eingeben, z.B. Bevölkerung"/>
  </ReactSpecimen>)}

With lots of tags:

${(<ReactSpecimen>
    <SearchField items={[]} selectedItems={sampleTagItems} onChange={() => { }} onInputFocus={() => { }} onInputBlur={() => { }} loading={false} inFocus={false} onSelect={() => { }} onRemoveTag={() => { }} placeholderText="Suchbegriff eingeben, z.B. Bevölkerung"/>
  </ReactSpecimen>)}

### In Focus

${(<ReactSpecimen>
    <div style={{ height: 150 }}>
      <SearchField items={[]} selectedItems={[{ label: "Foo", "@id": "foo", "@type": "Dimension" }]} onChange={() => { }} onInputFocus={() => { }} onInputBlur={() => { }} loading={false} inFocus={true} onSelect={() => { }} onRemoveTag={() => { }} placeholderText="Suchbegriff eingeben, z.B. Bevölkerung"/>
    </div>
  </ReactSpecimen>)}

## Autocomplete Suggestions

Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum ipsam cupiditate quis quibusdam commodi, ex ducimus esse sint ad, porro aspernatur labore reprehenderit error accusantium temporibus tenetur doloribus iste eligendi!

${(<ReactSpecimen responsive="small" span={2}>
    <AutocompleteSuggestions items={sampleTagItems} downshiftProps={{ getItemProps: () => { }, highlightedIndex: 1 }}/>
  </ReactSpecimen>)}

${(<ReactSpecimen responsive="medium" span={4}>
    <AutocompleteSuggestions items={sampleTagItems} downshiftProps={{ getItemProps: () => { }, highlightedIndex: 1 }}/>
  </ReactSpecimen>)}

#### No results

${(<ReactSpecimen>
    <AutocompleteSuggestions items={[]} downshiftProps={{ getItemProps: () => { }, highlightedIndex: 1 }}/>
  </ReactSpecimen>)}

#### Loading

${(<ReactSpecimen>
    <AutocompleteSuggestions items={sampleTagItems} loading downshiftProps={{ getItemProps: () => { }, highlightedIndex: 1 }}/>
  </ReactSpecimen>)}

`;



// WEBPACK FOOTER //
// ./src/search/Search.docs.tsx